module.exports = require('regenerate')().addRange(0x10880, 0x1089E).addRange(0x108A7, 0x108AF);